export const baseUrl =
  process.env.NODE_ENV === "development"
    ? "https://api.contactmate.fi/index.php"
    : "https://api.contactmate.fi/index.php";
export const localUrl = "https://cmevents.fi/";
export const defaultLogoUrl = "res/cme_logo_hb.png";
export const defaultBg = "darkgrey";
